import React, { useState, useEffect } from "react";
import Logo from "../../assets/SwalokGif.gif";
import { Link, NavLink } from "react-router-dom";
import Bharat from "../../assets/CBG Gas Outlet.pdf";
import GST from "../../assets/all in one excluding gst 1.pdf";
import Petrol from "../../assets/Petrol Pump Quotation.pdf";
import Techno from "../../assets/Techno-commercial 5 TPD.pdf";
import TC from "../../assets/Techno-commercial offer -2TPD.pdf";
import EV from "../../assets/EV Frienchisee .jpg.jpeg";

const Header = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleLinkClick = () => {
    setIsCollapsed(true);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {

        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };


    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <nav
        style={{ padding: "0" }}
        className={`navbar navbar-expand-lg sticky-top ${isScrolled ? "bg-white shadow-sm" : ""
          }`}
      >
        <div className="container">
          <Link className="navbar-brand py-0" to="/">
            <img
              src={Logo}
              className="img-fluid"
              alt="Site Logo"
              width={"150px"}
            />
          </Link>
          <button
            className="navbar-toggler"
            onClick={() => setIsCollapsed(!isCollapsed)}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fa-solid fa-bars"></i>
          </button>
          <div
            className={`collapse navbar-collapse justify-content-center ${isCollapsed ? "" : "show"
              }`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item my-2">
                <NavLink
                  className="nav-text"
                  activeclassname="active"
                  onClick={handleLinkClick}
                  to="/"
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item my-2">
                <NavLink
                  className="nav-text"
                  activeclassname="active"
                  onClick={handleLinkClick}
                  to="/about"
                >
                  About
                </NavLink>
              </li>
              <li className="nav-item my-2">
                <NavLink
                  className="nav-text"
                  activeclassname="active"
                  onClick={handleLinkClick}
                  to="/projects"
                >
                  Projects
                </NavLink>
              </li>
              <li className="nav-item dropdown my-2">
                <span
                  className="nav-text dropdown-toggle"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Members
                </span>
                <ul
                  className="dropdown-menu border-0 px-2"
                  aria-labelledby="navbarDropdown"
                >
                  <li className="my-2">
                    <Link className="nav-text" to="/members/avinash-kumar">
                      Avanish Kumar
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link className="nav-text" to="/members/raj-kumar">
                      Raj Kumar
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link className="nav-text" to="/members/niraj-pandey">
                      Niraj Pandey
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link className="nav-text" to="/members/krishna-kumar">
                      Krishna Kumar
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link className="nav-text" to="/members/abhishek-rai">
                      Abhishek Rai
                    </Link>
                  </li>
                  <li className="my-2">
                    <Link className="nav-text" to="/members/sagar-kataria">
                      Sagar Kataria
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="nav-item my-2">
                <NavLink
                  className="nav-text"
                  activeclassname="active"
                  onClick={handleLinkClick}
                  to="/blogs"
                >
                  Blogs
                </NavLink>
              </li>
              <li className="nav-item my-2">
                <NavLink
                  className="nav-text"
                  activeclassname="active"
                  onClick={handleLinkClick}
                  to="/contact"
                >
                  Contact
                </NavLink>
              </li>

              <li className="nav-item dropdown my-2">
                <span
                  className="nav-text dropdown-toggle"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Downloads
                </span>
               <ul className="dropdown-menu border-0 px-2" aria-labelledby="navbarDropdown">

  <li>
    <a href={Bharat} target="_blank" rel="noopener noreferrer"
       className="dropdown-item text-wrap small">
      CNG Station
    </a>
  </li>

  <li>
    <a href={GST} target="_blank" rel="noopener noreferrer"
       className="dropdown-item text-wrap small">
      AIO
    </a>
  </li>

  <li>
    <a href={Petrol} target="_blank" rel="noopener noreferrer"
       className="dropdown-item text-wrap small">
      Bio Diesel
    </a>
  </li>

  <li>
    <a href={Techno} target="_blank" rel="noopener noreferrer"
       className="dropdown-item text-wrap small">
      BHARAT ENERGREEN
    </a>
  </li>

  <li>
    <a href={TC} target="_blank" rel="noopener noreferrer"
       className="dropdown-item text-wrap small">
      COMPRESSED BIOGAS
    </a>
  </li>

  <li>
    <a href={EV} target="_blank" rel="noopener noreferrer"
       className="dropdown-item text-wrap small">
      EV 
    </a>
  </li>

</ul>
              </li>

              <li className="nav-item my-2">
                <NavLink
                  className="banner-btn py-2 px-4"
                  onClick={handleLinkClick}
                  to="/account"
                >
                  Login
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
